export enum CitationBlockType {
    text,
    number,
    url,
    year,
    month
}
